import mediaQueries from './lib/mediaQueries';

export const mediaQuery = mediaQueries; // eslint-disable-line import/prefer-default-export
